import { render, staticRenderFns } from "./Lianxi.vue?vue&type=template&id=e2d99114&scoped=true&"
import script from "./Lianxi.vue?vue&type=script&lang=js&"
export * from "./Lianxi.vue?vue&type=script&lang=js&"
import style0 from "./Lianxi.vue?vue&type=style&index=0&id=e2d99114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d99114",
  null
  
)

export default component.exports